import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { CreateTeamEventRequest } from '@lemoment/shared';

import { cancelTeamEvent, createTeamEvent } from '../apis';
import { teamKeys } from './teamKeys';

/** Refresh every team-event view (today card + calendar month) after a change. */
const useInvalidateTeamEvents = () => {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: teamKeys.events });
};

export const useCreateTeamEvent = () => {
  const invalidate = useInvalidateTeamEvents();
  return useMutation({
    mutationFn: (body: CreateTeamEventRequest) => createTeamEvent(body),
    onSuccess: invalidate,
  });
};

export const useCancelTeamEvent = () => {
  const invalidate = useInvalidateTeamEvents();
  return useMutation({
    mutationFn: (id: string) => cancelTeamEvent(id),
    onSuccess: invalidate,
  });
};
